import type { ApolloError } from "@apollo/client";
import { Alert, Box } from "@mui/material";

import { GaiaExpandableMapMarkerBody } from "~/modules/plannerV2/components/GaiaExpandableMapMarker/GaiaExpandableMapMarkerBody";

import { GaiaExpandableMapMarkerAreaBodyFragment } from "./fragments.generated";
import { GaiaExpandableMapMarkerAreaBodyAddVisitSection } from "./GaiaExpandableMapMarkerAreaBodyAddVisitSection";

type AreaBodyProps = {
    possibleAdjacentVisits: GaiaExpandableMapMarkerAreaBodyFragment["combinable"];
    onVisitAdd: (timeslotId: string, visitId: string) => void;
    disabled: boolean;
    error?: ApolloError;
};

export function GaiaExpandableMapMarkerAreaBody({
    possibleAdjacentVisits,
    onVisitAdd,
    disabled,
    error,
}: AreaBodyProps) {
    return (
        <GaiaExpandableMapMarkerBody>
            {error && <Alert severity="error">{error.message}</Alert>}
            <Box>
                <GaiaExpandableMapMarkerAreaBodyAddVisitSection
                    visits={possibleAdjacentVisits}
                    disabled={disabled}
                    onVisitAdd={onVisitAdd}
                />
            </Box>
        </GaiaExpandableMapMarkerBody>
    );
}
